import React, { useEffect, useState } from 'react'
import Header from './components/header/Header'
import Nav from './components/nav/Nav'
import About from './components/about/About'
import Skills from './components/skills/Skills'
import Portfolio from './components/portfolio/Portfolio'
import Hackathons from './components/hackthons/Hackathons'
import Contact from './components/contact/Contact'
import Footer from './components/footer/Footer'
import Experience from './components/Experience/Experience'
import Projects from './components/Projects/Projects'
import TechnicalSkills from './components/TechnicalSkills/TechnicalSkills'

const getSystemTheme = () => {
  if (typeof window === 'undefined') return 'dark'

  const preferredTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  const storedTheme = localStorage.getItem('portfolio-theme')

  return storedTheme === 'light' || storedTheme === 'dark' ? storedTheme : preferredTheme
}

const App = () => {
  const [theme, setTheme] = useState(getSystemTheme)

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme)
    localStorage.setItem('portfolio-theme', theme)
  }, [theme])

  useEffect(() => {
    if (typeof window === 'undefined') return undefined

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')

    const handleSystemThemeChange = (event) => {
      const storedTheme = localStorage.getItem('portfolio-theme')

      if (!storedTheme) {
        setTheme(event.matches ? 'dark' : 'light')
      }
    }

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', handleSystemThemeChange)
      return () => mediaQuery.removeEventListener('change', handleSystemThemeChange)
    }

    mediaQuery.addListener(handleSystemThemeChange)
    return () => mediaQuery.removeListener(handleSystemThemeChange)
  }, [])

  const toggleTheme = () => {
    setTheme((currentTheme) => (currentTheme === 'dark' ? 'light' : 'dark'))
  }

  return (
    <>
      <button
        type="button"
        className="theme-toggle"
        onClick={toggleTheme}
        aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
        title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        {theme === 'dark' ? '☀️' : '🌙'}
      </button>

      <div>
        <Header />
        <Experience />
        <Projects />
        <TechnicalSkills />
        {/* <Nav />
        <About /> */}
        {/* <Skills />
        <Portfolio />
        <Hackathons /> */}
        <Contact />
        <Footer />
      </div>
    </>
  )
}

export default App